module.exports = __webpack_public_path__ + "img/telios-pc.87138367.png";